/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

class ProductDetails {
  constructor (element) {
    this.$el = $(element)
  }
}

registerClass('ProductDetails', ProductDetails)
